import { render } from "./CreateActivity.vue?vue&type=template&id=4e0ed46c&ts=true"
import script from "./CreateActivity.vue?vue&type=script&lang=ts"
export * from "./CreateActivity.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__